"use strict";

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-ignore

var ethval_1 = __importDefault(require("ethval"));

var web3_utils_1 = require("web3-utils");

var Utils_1 = require("./Utils");

var AmountRequired = /*#__PURE__*/function () {
  function AmountRequired(name, requiredValue, logger, listener) {
    _classCallCheck(this, AmountRequired);

    this._currentValue = web3_utils_1.toBN(0);
    this._requiredValue = web3_utils_1.toBN(0);
    this.logger = logger;
    this._name = name;
    this._requiredValue = requiredValue;
    this._listener = listener;
  }

  _createClass(AmountRequired, [{
    key: "currentValue",
    get: function get() {
      return this._currentValue;
    },
    set: function set(newValue) {
      var didChange = !this._currentValue.eq(newValue);
      var wasSatisfied = this.isSatisfied;
      this._currentValue = newValue;

      if (didChange) {
        this._onChange(wasSatisfied);
      }
    }
  }, {
    key: "requiredValue",
    get: function get() {
      return this._requiredValue;
    },
    set: function set(newValue) {
      var didChange = !this._requiredValue.eq(newValue);
      var wasSatisfied = this.isSatisfied;
      this._requiredValue = newValue;

      if (didChange) {
        this._onChange(wasSatisfied);
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(wasSatisfied) {
      var changeString;

      if (wasSatisfied === this.isSatisfied) {
        changeString = "still".concat(this.isSatisfied ? '' : ' not');
      } else if (this.isSatisfied) {
        changeString = 'now';
      } else {
        changeString = 'no longer';
      }

      var message = "".concat(this._name, " requirement is ").concat(changeString, " satisfied\n").concat(this.description);
      this.logger.warn(message);

      if (this._listener != null) {
        this._listener();
      }
    }
  }, {
    key: "isSatisfied",
    get: function get() {
      return this._currentValue.gte(this._requiredValue);
    }
  }, {
    key: "description",
    get: function get() {
      var status = Utils_1.boolString(this.isSatisfied);
      var actual = new ethval_1.default(this._currentValue).toEth().toFixed(4);
      var required = new ethval_1.default(this._requiredValue).toEth().toFixed(4);
      return "".concat(this._name.padEnd(14), " | ").concat(status.padEnd(14), " | actual: ").concat(actual.padStart(12), " ETH | required: ").concat(required.padStart(12), " ETH");
    }
  }]);

  return AmountRequired;
}();

exports.AmountRequired = AmountRequired;